export const PAP_AFFILIATE_QUERY_PARAM = 'a_aid';
export const PAP_COOKIE = 'PAPCookie';
export const PAP_COOKIE_DOMAIN = '.mobilemonkey.com';
